import { Box, Icon, Link, Text, useToggle } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import RegularAccessModal from 'modules/employees/components/Actions/RegularAccessModal'
import { EmployeeStatusBannerEmployee } from 'modules/employees/components/blocks/EmployeeStatusBanner/types'

interface Props {
  employee: EmployeeStatusBannerEmployee
  contractStartDate?: string | null
  onboardingProcessName?: string
}

const InvitationAccepted = ({ employee, contractStartDate, onboardingProcessName }: Props) => {
  const [openRegularAccessModal, toggleRegularAccessModal] = useToggle(false)

  return (
    <Box paddingBottom="s32" paddingX="s64">
      <Box
        borderRadius={{ all: 'abs016' }}
        background="viridian100"
        padding="s12"
        paddingLeft="s16"
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
          <Box gap="s12" flexDirection="row" alignItems="center" paddingRight="s64">
            <Box background="viridian1000" borderRadius={{ all: 'abs008' }} padding="s2">
              <Icon.Medium icon="lightbulb" color="grey000White" />
            </Box>
            <Text.Normal weight="medium">
              {i18n.t('employees.creation.invitation_accepted.with_onboarding_process', {
                employee_name: employee.fullName,
                start_date: contractStartDate
                  ? i18nDateToString(moment(contractStartDate), 'ui')
                  : '',
                onboarding_name: onboardingProcessName,
              })}
            </Text.Normal>
          </Box>
          {!employee.hasRegularAccess && (
            <Box flexNoShrink>
              <Link.Touchable onClick={toggleRegularAccessModal(true)}>
                {i18n.t('employees.regular_access_action')}
              </Link.Touchable>
            </Box>
          )}
        </Box>
      </Box>
      {openRegularAccessModal && (
        <Box width="full">
          <RegularAccessModal employeeId={employee.id} onClose={toggleRegularAccessModal(false)} />
        </Box>
      )}
    </Box>
  )
}

export default observer(InvitationAccepted)
